<svelte:options tag="w-filter" />

<script>
    import { createEventDispatcher, onMount, beforeUpdate } from "svelte";

    import FilterItem from "./FilterItem.svelte";

    const dispatch = createEventDispatcher();

    export let filter = {};
    export let year;

    let params = {
        category: "",
        country: "",
        agency: "",
        medal: "",
        keywords: "",
        anio: "",
    };

    const handleFilter = (event) => {
        const field = event.detail ? event.detail.field : event.target.id;
        const selected = event.detail
            ? event.detail.selected
            : event.target.value;
        params[field] = selected;

        dispatch("search", params);
    };
    $: params.anio = year;
</script>

<div class="sec-filter">
    <div class="row">
        <div class="col-sm-6 col-md-3">
            <FilterItem
                on:filterChanged={handleFilter}
                header="Año"
                title="Selecciona Año"
                field="anio"
                selected={params.anio}
                list={['2024', '2023','2022']}
            />
        </div>
        <div class="col-sm-6 col-md-3">
            <FilterItem
                on:filterChanged={handleFilter}
                header="Disciplinas"
                title="Selecciona Disciplina"
                field="category"
                selected={params.category}
                list={filter.categories || []}
                id="id"
                value="name"
            />
        </div>
        <div class="col-sm-6 col-md-3">
            <FilterItem
                on:filterChanged={handleFilter}
                header="Metal"
                title="Selecciona Metal"
                field="medal"
                selected={params.medal}
                list={filter.medals || []}
            />
        </div>
        <div class="col-sm-6 col-md-3">
            <FilterItem
                on:filterChanged={handleFilter}
                header="Agencia"
                title="Selecciona Agencia"
                field="agency"
                selected={params.agency}
                list={filter.agencies || []}
            />
        </div>
        <div class="col-sm-6 col-md-3">
            <FilterItem
                on:filterChanged={handleFilter}
                header="País"
                title="Selecciona País"
                field="country"
                selected={params.country}
                list={filter.countries || []}
            />
        </div>
        <div class="col-sm-6 col-md-3">
            <label for="keywords">Keywords (Nombre de la compañia)</label>
            <div class="form-group">
                <input
                    bind:value={params.keywords}
                    on:keyup={handleFilter}
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    id="keywords"
                />
            </div>
        </div>
        <div class="col-sm-6 col-md-3">
            <a class="btn btn-search" href="/assets/GANADORESMETALESFIAP{params.anio}.xlsx" download="ganadores-metales-fiap.{params.anio}.xlsx">Excel de ganadores</a>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <a href="#hello" class="btn btn-search">Buscar</a>
        </div>
    </div>
</div>